// extracted by mini-css-extract-plugin
export default {"module-table":"ModuleSourceSection-module__module-table__x2AnE","moduleTable":"ModuleSourceSection-module__module-table__x2AnE"};